import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  regions: [],
  provincies: [],
  cities: [],
  isLoading: false,
  error: null
};

const regionSlice = createSlice({
  name: "regionData",
  initialState,
  reducers: {
    setRegions: (state, action) => {
      state.regions = action.payload;
    },
    setProvincies: (state, action) => {
      state.provincies = action.payload;
    },
    setCities: (state, action) => {
      state.cities = action.payload;
    },
    
    // API request states
    apiRequestStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    apiRequestSuccess: (state) => {
      state.isLoading = false;
    },
    apiRequestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});

// Export actions
export const {
  setRegions,
  setProvincies,
  setCities,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure
} = regionSlice.actions;
// console.log("state.regionData",state.regionData)
// Export selectors
export const selectRegions = (state) => state.region?.regions;
export const selectProvincies = (state) => state.region?.provincies;
export const selectCities = (state) => state.region?.cities;
export const selectIsLoading = (state) => state.regionData?.isLoading;
export const selectError = (state) => state.regionData?.error;

// Export reducer
export default regionSlice.reducer;